import styled from 'styled-components';
import * as variables from './../../assets/css/variables';

export const Container = styled.section`
    display: flex;
    flex-direction: column;
    position: relative;
    padding: 1.5rem;
    align-items: center;
    justify-content: center;
    
    .header__close {
        width: 1.5rem;
        position: absolute;
        top: 1rem;
        right: 1rem;
        cursor: pointer;
    }
    
    .header__image {
        margin-top: 4.4435714285714285rem;
        margin-bottom: 2.869285714285714rem;
        width: 4.3307142857142855rem;
    }
    
    hgroup {
        margin-bottom: 3.579285714285714rem;
        max-width: 70%;
        text-align: center;
    }
    
    h1 {
        font-size: 1.1428571428571428rem;
        margin-bottom: 0.3407142857142857rem;
        padding: 0;
    }
    
    h6 {
        font-size: 0.8571428571428571rem;
        margin: 0;
        padding: 0;
        font-weight: normal;
    }
    
    .ui.button {
        margin-bottom: 3.0042857142857144rem;
        background-color: ${variables.COLOR_BLUE};
        color: #FFF;
        font-size: 1rem;
        width: 13.360714285714286rem;
        border-radius: 5rem;
    }
    
    @media (min-width: 550px) {
      h1 {
        font-size: 2rem;
      }
      
      h6 {
        font-size: 1.3rem;
      }
    }
`;